module.exports = [{
      plugin: require('/Users/mac/developments/hello/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
